// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__vs5WZ","video":"style_video__q3z9s","playIcon":"style_play-icon__1Z3Rg"};